export default {"src":"/_next/static/media/scipy.0c3c9f53.svg","height":560,"width":560};